import React, { useRef } from 'react';

import Util from '$utilities';
import { Footer, Header } from '$partials/global';
import { Carousel, CarouselWrapper } from '$partials/base/carousel';
import { SwiperSlide } from 'swiper/react';
import { WorkListingItem } from '$partials/items';
import { Button } from '$partials/ui';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').ErrorPage}
 */
const ErrorPage = (props) => {
    const bodyRef = useRef();
    const status = Util.try(() => props.err.statusCode) || 500;

    let heading = '';
    switch(status) {
        case 404:
            heading = props?.data?.errorPageSettings?.heading404 || 'Sorry, we couldn’t find that page';
            break;
        case 500:
            heading = props?.data?.errorPageSettings?.heading500 || 'Sorry, something went wrong';
            break;
        default:
            heading = 'Sorry, something went wrong.';
    }

    const parentUrl = props?.data?.errorPageSettings?.latestProjects?.[0]?.parent;
    const allTags = props.data?.errorPageSettings?.latestProjects?.map(project => project.sectors).filter(project => !!project) || [];
    const tags = [...new Map(allTags.flat().map(item => [item.id, item])).values()];

    return (
        <>
            <Header
                {...props?.data?.header}
                bodyRef={bodyRef}
                domain={props.domain}/>
            <div className='min-h-[calc(100dvh-36px)] flex flex-col'>
                <main
                    id='main-content'
                    ref={bodyRef}>
                    <div className='px-layout-outer pt-[60px] sm:pt-[100px] sticky top-0 bg-[white] z-10'>
                        <div className='-mx-layout-col flex'>
                            <div className='px-layout-col flex flex-col w-full sm:w-3/7'>
                                <h1 className='mb-16'>
                                    {heading}
                                </h1>
                                <button
                                    className='type-style-s underline-offset-2 underline text-text-default-secondary flex self-start'
                                    onClick={() => window.history.back()}
                                    type='button'>
                                    {'Return to previous page'}
                                </button>
                            </div>
                        </div>
                    </div>
                </main>
                {props.data?.errorPageSettings?.latestProjects?.length > 0 && parentUrl && (
                    <section className='pt-[100px] bg-[white] z-10 relative'>
                        <div className='px-layout-outer py-16'>
                            <p>
                                {'View Latest Projects'}
                            </p>
                            {tags.length > 0 && (
                                <div className='pt-16 flex flex-wrap gap-4'>
                                    {tags.map(tag => {
                                        return (
                                            <Button
                                                as='a'
                                                className='button-tag'
                                                href={`${parentUrl?.url}?${tag.slug}`}
                                                key={tag.id}>
                                                {tag.title}
                                            </Button>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                        <Carousel
                            swiperConfig={{
                                a11y: { enabled: true },
                                slidesPerView: 1.15,
                                breakpoints: {
                                    992: {
                                        slidesPerView: 2.35,
                                    },
                                    1440: {
                                        slidesPerView: 3.55,
                                    }
                                },
                                spaceBetween: 0,
                                grabCursor: false,
                            }}>
                            <CarouselWrapper>
                                {props.data.errorPageSettings.latestProjects.map((item) => {
                                    const work = item;
                                    return (
                                        <SwiperSlide
                                            aria-roledescription='slide'
                                            className='cursor-pointer flex flex-wrap'
                                            key={work.id}
                                            role='group'>
                                            <WorkListingItem
                                                displayTitle={true}
                                                {...work} />
                                        </SwiperSlide>
                                    );
                                }).filter(Boolean)}
                            </CarouselWrapper>
                        </Carousel>
                    </section>
                )}

                <Footer {...props?.data?.footer} />
            </div>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ErrorPage;
